export default "__VITE_ASSET__3c6e630c__"